export enum PurchaseState {
  Pending,
  Accepted,
  Cancelled,
  Archived,
}
